import { render, staticRenderFns } from "./ObjectIdPublisher.vue?vue&type=template&id=0bed1d9d&"
import script from "./ObjectIdPublisher.vue?vue&type=script&lang=ts&"
export * from "./ObjectIdPublisher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports